module.exports = __webpack_public_path__ + "img/bk1.8aecee85.png";